<template lang="pug">
.view-platforms.content
  b-navbar.ui-navbar-secondary.is-primary()
    template(#start)
      // b-navbar-item(tag="router-link" :to="{name:'statCommon'}") Общая статистика
      b-navbar-item(tag="router-link" :to="{name:'statHelpdesk'}") Клиенты
      b-navbar-item(tag="router-link" :to="{name:'statPlatforms'}") Платформы
      // b-navbar-item(tag="router-link" :to="{name:'statServers'}") Серверы

  router-view

</template>

<script>
export default {
  name: 'view-stat',

  data: () => ({}),
};
</script>
